import React from 'react';
import { joinClassNames } from './joinClassNames.js';
const styles = {"button":"Button-module__button__T9ro8","primary":"Button-module__primary__dXv6K","secondary":"Button-module__secondary__gQ98-"};
const VARIANT_CLASS_NAMES = {
    primary: styles.primary,
    secondary: styles.secondary
};
export function Button({ label, onClick, type = 'button', disabled = false, variant = 'primary' }) {
    return (React.createElement("button", { className: joinClassNames(styles.button, VARIANT_CLASS_NAMES[variant]), type: type, disabled: disabled, onClick: onClick }, label));
}
//# sourceMappingURL=Button.js.map